import Head from 'next/head';
import {useRouter} from 'next/router';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {pathOr} from 'ramda';
import React from 'react';

import {getPreparedCourse} from '@/src/app/store/courseDetails/useCourseDetailsActions';
import CourseDetails from '@/src/courseDetails/containers/CourseDetails';
import getCourseDetails from '@/src/courseDetails/utils/getCourseDetails';

import {PREVIEW_IMAGE_PATH} from '../../job-portal/position/[slug]';

const CourseDetailsPage = ({title, description, host, serverProps}) => {
  const {asPath} = useRouter();

  const fullPath = `https://${host}${asPath}`;
  const imagesPath = `https://${host}/${PREVIEW_IMAGE_PATH}`;

  return (
    <>
      <Head>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="title" content={title} />

        {/*Open Graph / Facebook*/}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={fullPath} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={imagesPath} />

        {/*Twitter*/}
        <meta name="twitter:site" content={host} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={imagesPath} />
      </Head>
      <CourseDetails serverCourse={serverProps} />
    </>
  );
};

export default CourseDetailsPage;
export const getServerSideProps = async ({locale, params}) => {
  try {
    const {responseBody} = await getCourseDetails(params.slug, undefined);

    const course = responseBody.data[0].course_translations.find(
      (course) => course.language === locale
    );

    const preparedCourse = getPreparedCourse(
      pathOr({}, ['data', 0], responseBody),
      params.slug,
      locale
    );

    return {
      props: {
        serverProps: preparedCourse,
        title: course.title,
        description: course.description,
        ...(await serverSideTranslations(locale, ['common'])),
      },
    };
  } catch (error) {
    return {
      props: {
        ...(await serverSideTranslations(locale, ['common'])),
      },
    };
  }
};
